export default __webpack_public_path__ + "media/Bitbucket_mobile.cef2f2e32e71e4ef2b23ab0839503fe2.svg";